import {User} from './user';

export class Blog {
  id?: string;
  author?: User;
  title?: string;
  summary?: string;
  body?: string;
  slug?: string;
  tags?: string[];
  createdAt = new Date();
  updatedAt: Date;
}
